import { defineMessages } from 'react-intl';

export const scope = 'app.components.InviteForm';

export default defineMessages({
  btnSendInvite: {
    id: `${scope}.btnSendInvite`,
    defaultMessage: 'Send Invite',
  },
  btnAddInviteRoles: {
    id: `${scope}.btnAddInviteRoles`,
    defaultMessage: 'Add Roles',
  },
});
